import React, { useState } from "react";
import { motion } from "framer-motion";
import { Home } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import {
  getSmartHomeSettings,
  saveSmartHomeSettings,
} from "@/lib/smartHomeSettings";
import { useCaregiverTranslation } from "@/hooks/useCaregiverTranslation";

export function SmartHomeSettingsSection() {
  const [enabled, setEnabled] = useState(getSmartHomeSettings().enabled);
  const { t } = useCaregiverTranslation();

  const handleToggle = (checked: boolean) => {
    saveSmartHomeSettings({ enabled: checked });
    setEnabled(checked);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-card rounded-2xl border border-border p-6"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-xl bg-primary/10 text-primary">
            <Home className="w-5 h-5" />
          </div>
          <div>
            <h2 className="text-lg font-bold">{t("smartHome")}</h2>
            <p className="text-sm text-muted-foreground">
              {enabled ? t("smartHomeEnabled") : t("smartHomeDisabled")}
            </p>
          </div>
        </div>
        <Switch checked={enabled} onCheckedChange={handleToggle} />
      </div>
    </motion.div>
  );
}
